import React from 'react';

// Retired writer-facing warning. The flag can still exist on a Framework.
export const THIN_GENRE_MARKER = '';

export default function ThinGenreMarker() {
  return null;
}

export function beatCiteLabel(beat) {
  if (!beat) return 'Example';
  const titles = (beat.cite_titles || []).filter(Boolean);
  if (beat.cite_kind === 'titles' && titles.length && titles.length < 3) {
    return `Pattern from: ${titles.slice(0, 2).join('; ')}`;
  }
  return 'Example';
}
